module.exports = __webpack_public_path__ + "static/media/bandage.c0165680.png";